/* Offcourt Club – gemeinsame Oberfläche
   Läuft auf der Club-Startseite und auf allen Club-Tools. Ergänzt die Tools von außen,
   ohne deren Logik zu ändern: Navigation, Sync-Status, Einführung, Bildschirm-Sperre,
   Ergebnis-Auswahl (Turnier), Favoriten und große Schaubilder (Training).
   Hinweise, Messung und App-Hinweis liegen in oc-ux.js. */
(function(){
  var TOOL = window.OC_TOOL_NAME || '';
  var MEMBER = !!window.OC_MEMBER;
  var CUSTOMER = !!window.OC_CUSTOMER;
  var app = document.getElementById('oc-app');
  var mobile = window.matchMedia && matchMedia('(max-width: 899px)').matches;

  function get(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
  function set(k, v){ try { localStorage.setItem(k, v); } catch(e){} }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  /* ---------------- Navigation ---------------- */
  var ICON = {
    club: '<path d="M4 11.5L12 5l8 6.5"/><path d="M6.5 10v9h11v-9"/><path d="M10 19v-5h4v5"/>',
    turnier: '<path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4z"/><path d="M7 6H4v1.5A3.5 3.5 0 0 0 7.5 11M17 6h3v1.5a3.5 3.5 0 0 1-3.5 3.5"/>',
    match: '<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="M12 5v14"/><path d="M6.5 10h2.5v4H6.5zM15 10h2.5M17.5 10v4H15"/>',
    training: '<circle cx="12" cy="13.5" r="7.5"/><path d="M12 9.5v4l2.6 2.2M10 2.5h4"/>',
    stats: '<path d="M4 20h16"/><path d="M7 16v-4M12 16V7M17 16v-6"/>'
  };
  var NAV = [
    ['club', 'Club', '/pages/club'],
    ['turnier', 'Turnier', '/pages/turnierplaner-online'],
    ['match', 'Match', '/pages/match-zaehler'],
    ['training', 'Training', '/pages/trainings-generator'],
    ['stats', 'Statistik', '/pages/meine-statistik']
  ];
  function buildNav(){
    if (document.querySelector('.ocu-nav') || TOOL === 'finder') return;
    var path = location.pathname.replace(/\/$/, '');
    var cur = TOOL || (path === '/pages/club' ? 'club' : '');
    var nav = document.createElement('nav');
    nav.className = 'ocu-nav';
    nav.setAttribute('aria-label', 'Offcourt Club');
    nav.innerHTML = '<ul>' + NAV.map(function(n){
      return '<li><a href="' + n[2] + '"' + (n[0] === cur ? ' aria-current="page"' : '') + '><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICON[n[0]] + '</svg><span>' + n[1] + '</span></a></li>';
    }).join('') + '</ul>';
    if (mobile){ document.body.appendChild(nav); document.body.classList.add('ocu-has-nav'); }
    else {
      var anchor = app || document.querySelector('[id^="ocl-"]');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(nav, anchor); else document.body.appendChild(nav);
    }
  }

  /* ---------------- Statuszeile: Gast-Hinweis und Sync ---------------- */
  var SYNC_TXT = {saved: 'Gespeichert', saving: 'Speichert …', offline: 'Offline – wird nachgeholt', local: 'Nur auf diesem Gerät'};
  var syncState = CUSTOMER ? 'saved' : 'local';
  function syncHtml(){ return '<span class="ocu-sync" data-s="' + syncState + '" role="status"><i></i>' + SYNC_TXT[syncState] + '</span>'; }
  function strip(){
    if (!app || TOOL === 'finder') return;
    var head = app.querySelector(':scope > header');
    if (!head || app.querySelector('.ocu-strip')) return;
    var s = document.createElement('div');
    s.className = 'ocu-strip';
    var club = window.OC_CLUB_URL || '/pages/club';
    var left = MEMBER ? '<span class="ocu-guest"><b>Club</b> Alle Funktionen freigeschaltet</span>'
      : '<span class="ocu-guest"><b>Gratis</b> Club-Funktionen sind markiert · <a href="' + club + '">Mehr zum Club</a></span>';
    s.innerHTML = left + (TOOL === 'stats' && !MEMBER ? '' : syncHtml());
    head.insertAdjacentElement('afterend', s);
  }
  document.addEventListener('oc-sync', function(e){
    syncState = (e.detail && e.detail.state) || syncState;
    var el = document.querySelector('.ocu-sync');
    if (el){ el.setAttribute('data-s', syncState); el.innerHTML = '<i></i>' + SYNC_TXT[syncState]; }
  });

  /* ---------------- Einführung beim ersten Öffnen ---------------- */
  var INTRO = {
    turnier: ['Unter „Einrichten“ Spielform, Spieler und Punkte wählen.', 'Unter „Runden“ ein Ergebnis antippen – das Ergebnis des anderen Teams ergänzt sich von selbst.', '„Halle“ zeigt Spielplan, Timer und Rangliste groß für alle.'],
    match: ['Teams, Format und Aufschlag wählen und starten.', 'Auf die Hälfte des Teams tippen, das den Punkt gewinnt.', 'Vertippt? „Rückgängig“ nimmt den letzten Punkt zurück.'],
    training: ['Spielerzahl, Level, Dauer und Schwerpunkt wählen.', 'Übungen tauschen oder mit dem Stern merken.', '„Einheit starten“ – der Timer führt dich Übung für Übung durch.']
  };
  function intro(){
    var steps = INTRO[TOOL], main = app && app.querySelector('#oc-main');
    if (!steps || !main || get('ocu-intro-' + TOOL) || app.querySelector('.ocu-intro')) return;
    var box = document.createElement('div');
    box.className = 'ocu-intro';
    box.innerHTML = '<div class="t">So funktioniert’s<button type="button" class="ocu-x">Verstanden</button></div><ol>' + steps.map(function(s){ return '<li>' + esc(s) + '</li>'; }).join('') + '</ol>';
    main.parentNode.insertBefore(box, main);
    box.querySelector('button').onclick = function(){ set('ocu-intro-' + TOOL, '1'); box.remove(); };
  }

  /* ---------------- Bildschirm bleibt an (Court, Training, Halle) ---------------- */
  var lock = null;
  function needLock(){ return !!(app && app.querySelector('#court:not([hidden]), #run:not([hidden]), #hall:not([hidden])')); }
  function syncLock(){
    if (!('wakeLock' in navigator)) return;
    if (needLock() && document.visibilityState === 'visible'){
      if (!lock) navigator.wakeLock.request('screen').then(function(l){ lock = l; l.addEventListener('release', function(){ lock = null; }); }).catch(function(){});
    } else if (lock){ try { lock.release(); } catch(e){} lock = null; }
  }
  document.addEventListener('visibilitychange', syncLock);

  /* ---------------- Turnier: Ergebnis per Auswahl statt Tastatur ---------------- */
  function scoreSheet(){
    if (TOOL !== 'turnier' || !app) return;
    var sheet = document.createElement('div');
    sheet.className = 'ocu-sheet'; sheet.hidden = true;
    sheet.innerHTML = '<div class="in" role="dialog" aria-modal="true" aria-labelledby="ocu-sh-nm"><div class="hd"><div><div class="k" id="ocu-sh-k"></div><div class="nm" id="ocu-sh-nm"></div></div><button type="button" class="ocu-x" id="ocu-sh-x">Abbrechen</button></div><div class="grid" id="ocu-sh-g"></div><div class="row" style="display:flex;gap:10px;align-items:center"><button type="button" class="ocu-x" id="ocu-sh-c">Ergebnis löschen</button><span class="note">Das andere Team wird automatisch ergänzt.</span></div></div>';
    document.body.appendChild(sheet);
    var target = null;
    function close(){ sheet.hidden = true; if (target) try { target.focus({preventScroll:true}); target.blur(); } catch(e){} target = null; }
    function apply(v){
      if (!target) return;
      var t = target; close();
      t.value = v; t.dispatchEvent(new Event('change', {bubbles:true}));
    }
    sheet.addEventListener('click', function(e){ if (e.target === sheet) close(); });
    sheet.querySelector('#ocu-sh-x').onclick = close;
    sheet.querySelector('#ocu-sh-c').onclick = function(){ apply(''); };
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !sheet.hidden) close(); });
    app.addEventListener('pointerdown', function(e){
      var inp = e.target.closest && e.target.closest('.match input[type=number]');
      if (!inp || e.pointerType === 'pen') return;
      e.preventDefault();
      target = inp;
      var max = +inp.max || 24, cur = inp.value === '' ? null : +inp.value;
      var row = inp.closest('.match'), teams = row ? row.querySelectorAll('.team') : [];
      var team = teams.length ? teams[inp.dataset.s === '1' ? 0 : 1].textContent : '';
      var court = row && row.querySelector('.court') ? row.querySelector('.court').textContent : '';
      sheet.querySelector('#ocu-sh-k').textContent = court + ' · Punkte für';
      sheet.querySelector('#ocu-sh-nm').textContent = team;
      var h = '';
      for (var v = 0; v <= max; v++) h += '<button type="button" data-v="' + v + '"' + (cur === v ? ' aria-pressed="true"' : '') + (v * 2 === max ? ' class="half"' : '') + '>' + v + '</button>';
      var g = sheet.querySelector('#ocu-sh-g'); g.innerHTML = h;
      g.querySelectorAll('button').forEach(function(b){ b.onclick = function(){ apply(b.dataset.v); }; });
      sheet.hidden = false;
      var sel = g.querySelector('[aria-pressed="true"]') || g.querySelector('.half');
      if (sel) sel.focus({preventScroll:true});
    });
  }

  /* ---------------- Training: Favoriten ---------------- */
  var FK = 'oc-fav-v1';
  function favs(){ try { return JSON.parse(get(FK)) || []; } catch(e){ return []; } }
  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 3.2l2.6 5.5 6 .8-4.4 4.1 1.1 5.9L12 16.7l-5.3 2.8 1.1-5.9L3.4 9.5l6-.8z"/></svg>';
  function trainingExtras(){
    if (TOOL !== 'training' || !app || !MEMBER) return;
    var F = favs();
    app.querySelectorAll('#oc-main .drill:not(.ocu-fd)').forEach(function(el){
      var h = el.querySelector('h2'), meta = el.querySelector('.meta');
      if (!h || !meta || meta.querySelector('.ocu-fav')) return;
      var name = h.textContent.trim(), on = F.indexOf(name) >= 0;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ocu-fav'; b.setAttribute('aria-pressed', on);
      b.setAttribute('aria-label', name + (on ? ' aus Favoriten entfernen' : ' als Favorit merken'));
      b.innerHTML = STAR;
      b.onclick = function(){
        var L = favs(), i = L.indexOf(name);
        if (i >= 0) L.splice(i, 1); else L.push(name);
        set(FK, JSON.stringify(L));
        app.querySelectorAll('#oc-main .ocu-fav').forEach(function(x){ x.remove(); });
        var old = app.querySelector('.ocu-favs'); if (old) old.remove();
        trainingExtras();
      };
      meta.appendChild(b);
    });
    var planTab = app.querySelector('nav [data-tab="plan"][aria-selected="true"]');
    var stack = app.querySelector('#oc-main > .stack');
    if (!planTab || !stack || app.querySelector('.ocu-favs') || !F.length || !window.OC_DATA) return;
    var D = {}; (window.OC_DATA.drills || []).forEach(function(d){ D[d[1]] = d; });
    var CAT = {}; (window.OC_DATA.cats || []).forEach(function(c){ CAT[c[0]] = c[1]; });
    var items = F.filter(function(n){ return D[n]; }).map(function(n){
      var d = D[n];
      return '<div class="drill ocu-fd"><div class="min" style="color:#c98a00">★</div><div class="dn"><h2>' + esc(n) + '</h2><div class="meta"><span class="tag">' + esc(CAT[d[0]] || '') + '</span></div></div><span></span>' +
        '<details><summary>So geht’s</summary><div class="dl"><b>Ablauf</b><span>' + esc(d[5]) + '</span><b>Ziel</b><span>' + esc(d[6]) + '</span><b>Variante</b><span>' + esc(d[7]) + '</span><b>Achtung</b><span class="err">' + esc(d[8]) + '</span></div></details></div>';
    }).join('');
    if (!items) return;
    var box = document.createElement('details');
    box.className = 'card ocu-favs';
    box.innerHTML = '<summary>Meine Lieblingsübungen (' + F.length + ')</summary><div style="margin-top:6px">' + items + '</div>';
    var cards = stack.querySelectorAll(':scope > .card');
    var after = cards[1] || cards[0];
    if (after) after.insertAdjacentElement('afterend', box); else stack.appendChild(box);
  }

  /* ---------------- Schaubild groß ---------------- */
  function zoomSetup(){
    if (!app) return;
    var z = document.createElement('div');
    z.className = 'ocu-zoom'; z.hidden = true; z.setAttribute('role', 'dialog'); z.setAttribute('aria-modal', 'true');
    z.innerHTML = '<div class="top"><span id="ocu-z-t"></span><button type="button" class="ocu-x">Schließen</button></div><div class="fig" id="ocu-z-f"></div>';
    document.body.appendChild(z);
    var close = function(){ z.hidden = true; z.querySelector('#ocu-z-f').innerHTML = ''; };
    z.querySelector('button').onclick = close;
    z.addEventListener('click', function(e){ if (e.target === z || e.target.id === 'ocu-z-f') close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !z.hidden) close(); });
    app.addEventListener('click', function(e){
      var fig = e.target.closest && e.target.closest('figure.oc-court');
      if (!fig || z.contains(fig)) return;
      var holder = fig.closest('.drill') || fig.closest('#run');
      var t = holder ? (holder.querySelector('h2') || holder.querySelector('.rname')) : null;
      z.querySelector('#ocu-z-t').textContent = t ? t.textContent.trim() : 'Schaubild';
      var copy = fig.cloneNode(true);
      z.querySelector('#ocu-z-f').appendChild(copy);
      z.hidden = false;
      z.querySelector('button').focus();
    });
  }

  /* ---------------- Start ---------------- */
  function onChange(){ strip(); intro(); trainingExtras(); syncLock(); }
  function init(){
    buildNav();
    if (!app) return;
    scoreSheet(); zoomSetup();
    var busy = false;
    new MutationObserver(function(){ if (busy) return; busy = true; try { onChange(); } finally { busy = false; } })
      .observe(app, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-selected']});
    onChange();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();